import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";
import {
  AiConfigurationPayload,
  AiConfigurationResponse,
} from "../types/ai-configuration.type";
import { apiCall } from "../base";

export const AiConfiguration = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `AiConfiguration_${stringParams}`,
    handle: (): Promise<AiConfigurationResponse> =>
      apiCall<AiConfigurationResponse>({
        params,
        url: ENDPOINT.AI_CONFIGURATION,
        method: HttpMethod.GET,
      }),
  };
};

export const UpdateAiConfiguration = () => {
  return {
    name: "UpdateAiConfiguration",
    handle: ({
      workspaceId,
      configuration,
    }: AiConfigurationPayload): Promise<AiConfigurationResponse> => {
      return apiCall<AiConfigurationResponse>({
        url: `${ENDPOINT.AI_CONFIGURATION}`,
        method: HttpMethod.PUT,
        body: {
          workspaceId,
          configuration: configuration,
        },
      });
    },
  };
};
